import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Globals } from '../globals';
import { WSService } from '../include/service';

@Injectable({
  providedIn: 'root'
})
export class FormsService extends WSService<any> {

  constructor() { super("forms") };

  getForms(table):Observable<any[]>{
    return Globals.ws.requestUrl("forms","getItems",["f.table='"+table+"' and f.status=1"]);
  }

  /*getFormValue(id,reference,oncomplete){
    return Globals.ws.send("forms","getFormValue",reference,[id],oncomplete);
 
  }*/

  getForm(id,reference,oncomplete,id_formvalue=0){

    if(Globals.ws.api_version=="v1"){
      return Globals.ws.send("forms","getForm",reference,[id,id_formvalue,reference],oncomplete);
 
    }else{

      let data={
        "id":id,
        "id_formvalue":id_formvalue,
        "record":reference
      }

      return Globals.ws.send("forms","getForm",data,[],oncomplete);
 
    }
    
    
 
  }

}
